(function () {
	'use strict';

	angular.module('app.core')
		.directive('progressChart', progressChart);

	function progressChart($window, $filter, $rootScope, $timeout, $translate) {

		return {
			restrict: 'A',
			scope: {
				itemType: '@',
				categories: '=',
				chartHeight: '=',
				yAxisLabelWide: '@'
			},
			link: function (scope, elem, attrs) {
				var scopeAccessor = scope.$parent.$parent;

				scope.chartData = scopeAccessor.chartData;
				var chart;
				var progressSummaryListener;
				var taskSummaryListener;
				var yAxisFieldLabel = '';
				var xAxisFieldLabel = '';
				var data = [];
				var fmtService = {};

				var w = angular.element($window);
				var width = Math.max(w.width(), window.innerWidth);
				scope.height = window.innerHeight;
				scope.paddingTop = 4;
				scope.paddingBottom = 0;
				// give element unique id
				elem[0].id = elem[0].id + scope.$id;
				var chartHeight = 250;
				if (scope.chartHeight) {
					chartHeight = scope.chartHeight;
				}

				var slideshow = false;
				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					slideshow = true;
					scope.paddingTop = 8;
					scope.paddingBottom = 12;
				}
				setPadding();

				scope.$watch(getWindowDimensions2, function (newValue, oldValue) {
					scope.windowWidth2 = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLt;

					setPadding();

					if (currentPaddingLeft !== scope.paddingLt || newValue.h !== oldValue.h) {
						generateChart();
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				function getWindowDimensions2() {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				}

				function setPadding() {
					if (slideshow) {
						chartHeight = scope.height - 130;
					} else if (scope.windowWidth2 >= 992) {
						scope.paddingLt = 95;
						scope.paddingRt = 59;
						scope.axisLabelWidth = 50;
					} else if (scope.windowWidth2 >= 768) {
						scope.paddingLt = 70;
						scope.paddingRt = 48;
						scope.axisLabelWidth = 50;
					} else {
						scope.paddingLt = 70;
						scope.paddingRt = 36;
						scope.axisLabelWidth = 30;
					}
				}

				function generateChart() {
					var i;
					var groups = ['Completed', 'Started', 'Pending'];
					var translatedValues = {
						'Completed': $translate.instant('Completed'),
						'Started': $translate.instant('Started'),
						'Pending': $translate.instant('Pending')
					};
					scope.translatedValues = translatedValues;
					var data = scopeAccessor.chartData;

					// count tasks in groups and generate tick values
					var maxItemCount = 0;
					for (i = 0; i < data.length; i++) {
						var itemCount = data[i].Completed + data[i].Started + data[i].Pending;
						if (itemCount > maxItemCount) {
							maxItemCount = itemCount;
						}
					}
					var tickValues = [];
					var interval = 1;
					if (maxItemCount > 12) {
						interval = maxItemCount / 6;
					}
					for (i = 0; i <= maxItemCount; i += interval) {
						tickValues.push(i);
					}
					
					var yAxisCategories = scopeAccessor.categories;

					var config = {};
					// tell c3 where to put the chart
					config.bindto = '#' + elem[0].id;
					config.size = {
						height: chartHeight
					};
					config.padding = {
						right: scope.paddingRt,
						left: scope.paddingLt,
						top: scope.paddingTop
					};

					config.data = {
						json: data,
						type: 'bar',
						keys: {
							value: groups
						},
						groups: [groups],
						names: translatedValues,
						order: null,
						color: function (color, d) {
							var colorCode = color;
							if (d === 'Completed' || d.id === 'Completed') {
								colorCode = '#0C9D4D';
							} else if (d === 'Started' || d.id === 'Started') {
								colorCode = '#A8F4CA';
							} else if (d === 'Pending' || d.id === 'Pending') {
								colorCode = '#E0E0E0';
							}
							return colorCode;
						}
					};

					config.grid = {
						x: {
							show: false
						},
						y: {
							show: true
						}
					};

					config.legend = {
						show: true
					};

					config.axis = {
						rotated: true,
						x: {
							type: 'category',
							categories: yAxisCategories,
							tick: {
								width: scope.axisLabelWidth
							}
						},
						y: {
							tick: {
								format: function (d) {
									return $filter('number')(d, 0);
								},
								values: tickValues
							}
						}
					};
					if (scope.yAxisLabelWide) {
						config.axis.x.tick.width = 200;
						config.padding.left = 150;
					}
					chart = c3.generate(config);
				}


				scope.$watch(function () {
					return jQuery('.progress-chart .c3-legend-item-tile').last().attr('x1');
				});

				if (scope.itemType === 'task') {
					progressSummaryListener = scope.$on('event:leanProjectTaskSummaryCtrl:getChart', function () {
						generateChart();
					});
				} else if (scope.itemType === 'project') {
					taskSummaryListener = scope.$on('event:leanProjectProgressSummaryCtrl:getChart', function () {
						generateChart();
					});
				}

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (progressSummaryListener) {
						progressSummaryListener();
					}
					if (taskSummaryListener) {
						taskSummaryListener();
					}
				});
			}
		};
	}
})();
